module.exports = "/assets/6f1ac809304eac256edb7bbb0f94d9ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AR.png
// module id = 2334
// module chunks = 0